import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../Context';
import s from './StageContainer.scss';
export const StageContainer = ({ children, className })=>{
    const { isTheater, isFullscreen } = useDeviationViewContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stage-content']
    }, children));
};
StageContainer.displayName = 'StageContainer';
export default StageContainer;
